import React, { Fragment } from 'react';
import DemoForm from '../../components/site/Forms/DemoForm';
import DemoFormB2B from '../../components/site/Forms/DemoFormB2B';
import Picture from '../../components/Picture';
import './FinalCTACard.scss';

const FinalCTACard = ({
    title,
    description,
    buttonVariant,
    useB2BForm,
    useMinimalStyle,
    useWhatsAppStyle,
    submitButtonText,
    modalButtonText,
    trialAndDemo,
    showTrialLink,
    showTrialInfo,
    titleTag = 'h4'
}) => {
    const TitleTag = titleTag;

    return (
        <div className="final-cta-card-section">
            <div className="container">
                <div className="cta-card">
                    <div className="cta-content">
                        <div className="cta-text">
                            <TitleTag className="cta-title">{title || 'Peça uma demonstração e fale com um de nossos especialistas pelo Whatsapp'}</TitleTag>
                            <p>{description || 'Ainda com dúvidas? Clique abaixo, cadastre seus dados e fale diretamente com nosso time de especialistas!'}</p>
                        </div>
                        <div className="cta-button">
                            {useWhatsAppStyle ? (
                                <DemoForm
                                    newForm={false}
                                    trialButtonOnly
                                    modalButtonText={
                                        <Fragment>
                                            <Picture src="/images/site/whatsapp.png" alt="Ícone do Whatsapp" />
                                            Falar com especialista
                                        </Fragment>
                                    }
                                    className="whatsapp-styled-demo"
                                />
                            ) : useMinimalStyle ? (
                                <DemoForm
                                    minimalStyle={true}
                                    trialAndDemo={trialAndDemo || 'comece grátis'}
                                    showForm
                                    submitButtonText={submitButtonText || 'Solicitar demonstração'}
                                    modalButtonText={modalButtonText || 'Peça uma demonstração'}
                                    showTrialLink={false}
                                    className="final-cta-form"
                                />
                            ) : useB2BForm ? (
                                <Fragment>
                                    <DemoFormB2B
                                        trialAndDemo={trialAndDemo || 'comece grátis'}
                                        showForm
                                        submitButtonText={submitButtonText || 'Solicitar demonstração'}
                                        modalButtonText={modalButtonText || 'Peça uma demonstração'}
                                        showTrialLink={false}
                                    />
                                    {showTrialInfo && (
                                        <p className="cta-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>
                                    )}
                                </Fragment>
                            ) : (
                                <DemoForm
                                    buttonVariant={buttonVariant || 'inverted-white'}
                                    textAlign="center"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinalCTACard;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardFooter/FinalCTACard.jsx